//@ts-check
/** @param {Fox} fox */
module.exports = (fox) => {
	const $ = fox.jQuery;

	//@ts-ignore
	require('./stylus/_index.styl');
	//@ts-ignore
	require('./templates/strip.a.tpl')(fox);

	const NOT_VERIFIED_CLASS = 'not-verified';
	const VERIFIED_CLASS = 'verified';
	const VERIFICATION_SENT_CLASS = 'verification-sent';
	const VERIFICATION_FAILED_CLASS = 'verification-failed';
	const TIMEOUT = 10000;

	const storage = new fox.LocalStorageObjectService({
		lsLabel: '_evs_',
		cleanCheckInterval: null
	});

	const STATES = {
		NOT_VERIFIED: 0,
		VERIFIED: 1,
		SENT: 2,
		SENDING: 3,
		SEND_FAILED: 4,
		FAILED: 5,
		NONE: null
	};

	fox.registerWidget('EmailVerificationNotify', {
		configure() {
			this.registerOptions('', {
				autoRender: true,
				template: 'strip_notification',
				handleDom: {
					sendVerification: {
						target: '#send-verification',
						callback: 'sendEmailVerification'
					},
					scroll: {
						event: 'scroll',
						target: document,
						eventChecker: _ => this.isEmbedded(),
						callback: () => {
							const bar = $(this.dom1('.strip-notification-wrapper'));
							const barHeight = bar.height();
							const scrollTop = $(window).scrollTop();

							return scrollTop > barHeight + barHeight / 2 ?
								bar.addClass('sticky') :
								bar.removeClass('sticky');
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},


		init() {
			this.userEmail = this.requireOption('getUserEmailCb');
			this.verified = this.requireOption('getVerificationStateCb');

			this.callParent('init', arguments);
		},

		prepareEmbeddedWidgets() {
			this._bindData = {
				status: STATES.NOE,
				stripClass: '',
				opened: false
			};

			this.bindTemplateVariables(this._bindData, [
				'status', 'stripClass', 'opened'
			]);

			this.callParent('prepareEmbeddedWidgets', arguments);
		},

		beforeRender() {
			let stripClass;
			let status;

			switch (this.verified()) {
				case true:
					status = STATES.VERIFIED;
					stripClass = VERIFIED_CLASS
					break;
				case null:
					status = STATES.FAILED;
					stripClass = VERIFICATION_FAILED_CLASS;
					break;
				default:
					status = STATES.NOT_VERIFIED;
					stripClass = NOT_VERIFIED_CLASS
			}

			if (this.sendStatus) {
				if (this.sendStatus === STATES.SENDING) {
					stripClass = NOT_VERIFIED_CLASS;
					status = STATES.SENDING;
				} else if (this.sendStatus === STATES.SENT) {
					stripClass = VERIFICATION_SENT_CLASS;
					status = STATES.SENT;
				} else if (this.sendStatus === STATES.SEND_FAILED) {
					stripClass = VERIFICATION_FAILED_CLASS;
					status = STATES.SEND_FAILED;
				}
			}

			this._bindData.status = status;
			this._bindData.stripClass = stripClass;

			return this.callParent('beforeRender', arguments);
		},

		showStripIdNeeded() {
			const show = _ => {
				this.wait('@root .Site_Layout', 'addedToDom')
					.then(_ => setTimeout(_ => this.show(), 1000));
			}

			if (this._afterSendTimeout)
				return false;

			if (this.verified() === true) {
				const emailId = fox.getStringSimpleHash(this.userEmail(), 16);
				const availableInStorage = storage.getItem(emailId);

				if (!availableInStorage) {
					storage.setItem(emailId, {
						value: true
					});

					show();

					setTimeout(_ => {
						this.hide().then(_ => this.destroy());
					}, TIMEOUT);
				} else {
					this.unmount();
					this.destroy();
				}
			} else if ([null, false].indexOf(this.verified()) !== -1) {
				show();

				if (this.verified() === null) {
					setTimeout(_ => this.hide(), TIMEOUT);
				}
			}
		},

		sendEmailVerification() {
			this._bindData.status = this.sendStatus = STATES.SENDING;

			const api = this.getApi('emailVerificationApi', {
				method: 'User_Verification.sendEmailConfirmation'
			});

			return api.psend().then(_ => {
				return new fox.Promise(resolve => {
					this._bindData.status = this.sendStatus = STATES.SENT;

					setTimeout(resolve, TIMEOUT);
				});
			}).then(_ => {
				this._bindData.status = this.sendStatus = STATES.NONE;
				this.verified = () => false;
				this.hide();

				this._afterSendTimeout = setTimeout(_ => {
					clearTimeout(this._afterSendTimeout);
					delete this._afterSendTimeout;

					this.show();
				}, TIMEOUT * 2);
			}).catch(e => {
				this._bindData.status = this.sendStatus = STATES.SEND_FAILED;
				this.verified = () => false;

				setTimeout(_ => this.hide(), TIMEOUT);
			});
		},

		unmount() {
			const myNode = fox.dom.selectFirst('#email-verification');

			if (myNode) {
				myNode.parentNode.removeChild(myNode);
			}
		},

		removeFromDom() {
			const args = fox.clone(arguments);

			return new fox.Promise(resolve => {
				setTimeout(_ => {
					this.unmount();
					return resolve(true);
				}, 410);
			});
		},

		hide() {
			this._bindData.opened = false;
			return this.removeFromDom();
		},

		show() {
			if (this.isEmbedded()) {
				return this._bindData.opened = true;
			}

			this.wait('addedToDom').then(_ => {
				return this._bindData.opened = true;
			});
		},

		beforeEmbed() {
			if (this.rwom1('@root #permissionManager').hasAccess('guestActual')) {
				return false;
			}

			return this.callParent('beforeEmbed', arguments);
		}
	});
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/strip-notification/index.es.js